import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X, Crown } from 'lucide-react';
const currentState = ['Revisas su perfil 20 veces al día', 'Ansiedad cada vez que suena el teléfono', 'Noches sin dormir pensando en qué hiciste mal', 'Pierdes dignidad enviando mensajes que no responde', 'Tu autoestima depende de su validación'];
const transformedState = ['Recuperas el control de tu atención y tu tiempo', 'Paz mental real, sin sobresaltos digitales', 'Duermes tranquila sabiendo que elegiste tu poder', 'Silencio estratégico que habla más fuerte que mil textos', 'Tu valor viene de adentro, no de una respuesta'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function TransformationBlock() {
  return <section className="py-32 px-6 bg-charcoal-light relative border-t border-gold/10 overflow-hidden" data-id="element-195">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-196">
        <Crown className="w-48 h-48 text-gold/[0.03]" strokeWidth={0.5} data-id="element-197" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-199">
          <h2 className="font-playfair text-4xl md:text-5xl text-white mb-6" data-id="element-200">
            TU <span className="text-metallic-gold" data-id="element-201">TRANSFORMACIÓN</span>
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto opacity-50" data-id="element-202" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-0" data-id="element-203">
          {/* Current State */}
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-white/[0.02] md:rounded-l-md md:rounded-r-none rounded-md border border-white/5 p-8 sm:p-10" data-id="element-204">
            <h3 className="font-playfair text-xl text-gray-500 mb-8 pb-4 border-b border-white/5" data-id="element-205">
              Tu estado actual
            </h3>
            <ul className="space-y-5" data-id="element-206">
              {currentState.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-3" data-id="element-207">
                  <X className="w-5 h-5 text-red-900/60 flex-shrink-0 mt-0.5" strokeWidth={2} data-id="element-208" />
                  <span className="font-sans text-gray-500 font-light leading-relaxed" data-id="element-209">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Transformed State */}
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-gold/[0.04] md:rounded-r-md md:rounded-l-none rounded-md border border-gold/20 p-8 sm:p-10" data-id="element-210">
            <h3 className="font-playfair text-xl text-gold mb-8 pb-4 border-b border-gold/20" data-id="element-211">
              Tu estado con el <span className="italic" data-id="element-212">Código</span>
            </h3>
            <ul className="space-y-5" data-id="element-213">
              {transformedState.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-3" data-id="element-214">
                  <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 20 20" fill="none" data-id="element-215">
                    <path d="M4 10l4 4 8-8" stroke="url(#gold-check-grad)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-216" />
                    <defs data-id="element-217">
                      <linearGradient id="gold-check-grad" x1="4" y1="6" x2="16" y2="14" data-id="element-218">
                        <stop stopColor="#FCF6BA" data-id="element-219" />
                        <stop offset="0.5" stopColor="#D4AF37" data-id="element-220" />
                        <stop offset="1" stopColor="#B38728" data-id="element-221" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <span className="font-sans text-gray-200 font-light leading-relaxed" data-id="element-222">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}